export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA'
export const PUT_DASHBOARD_DATA = 'PUT_DASHBOARD_DATA'

export const SET_DASHBOARD_FILTERS = 'SET_DASHBOARD_FILTERS'
